import { render, staticRenderFns } from "./NewInboundSetup.vue?vue&type=template&id=c7356e32&scoped=true&"
import script from "./NewInboundSetup.vue?vue&type=script&lang=js&"
export * from "./NewInboundSetup.vue?vue&type=script&lang=js&"
import style0 from "./NewInboundSetup.vue?vue&type=style&index=0&id=c7356e32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7356e32",
  null
  
)

/* custom blocks */
import block0 from "./NewInboundSetup.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports